<article class="w-fit flex gap-4 align-items-center">
  <section *ngFor="let item of links"
           (click)="openLink(item.link)">
    <i class="bi {{item.icon}} ci-txt--black text-4xl cursor-pointer {{cssClass}}"></i>
  </section>
</article>